import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteInterviewTemplateModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`You are deleting an Interview template.`}
    message={t`Are you sure you want to delete?`}
    title={t`Delete Interview template`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
